<template>
  <section class="header-bar">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1000 20"
      class="product-bar__bar"
      preserveAspectRatio="none"
      width="100%"
      height="100%"
    >
      <polygon points="0,0  1000,0  1000,20 0,20" style="fill:black;" />
    </svg>
    <div class="header-bar__header">
      <img
        class="header-bar__header__logo"
        :class="{ 'make-transparent': showStaticLogo }"
        :style="{ width: this.logos.leftLogo.width }"
        :src="getImg(this.logos.leftLogo.img)"
        alt
      />
      <img
        v-if="this.logos.centerLogo"
        class="header-bar__header__center-logo"
        :style="{ width: this.logos.centerLogo.width }"
        :src="getImg(this.logos.centerLogo.img)"
        alt
        @click="reset"
      />
      <img
        v-if="this.logos.rightLogo"
        class="header-bar__header__logo-two"
        :style="{ width: this.logos.rightLogo.width }"
        :src="getImg(this.logos.rightLogo.img)"
        alt
      />
    </div>
  </section>
</template>

<script>
import logoSetData from "@/assets/json-data/logoSetData";
import { mapState } from "vuex";
export default {
  name: "header-bar",
  props: ["reset"],
  data() {
    return {
      logos: {}
    };
  },
  computed: {
    ...mapState({
      showStaticLogo: state => state.logos.showStaticLogo
    })
  },
  methods: {
    getImg(pic) {
      if (pic) {
        var image = require.context("@/assets/logos/", false);
        return image("./" + pic);
      }
    }
  },
  created() {
    this.logos = logoSetData();
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.header-bar {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 1.5vw;
  @media screen and (max-aspect-ratio: 256/135) {
    height: 3.5vw;
  }
  &__bar {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  &__header {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 1.5vw;
    z-index: 10;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    @media screen and (max-aspect-ratio: 256/135) {
      height: 3.5vw;
    }
    &__logo {
      margin-left: 2vw;
    }
    &__center-logo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &__logo-two {
      margin-right: 2vw;
    }
  }
}
</style>
